module.exports = __webpack_public_path__ + "img/slide_v2.35eede04.png";